module.exports = __webpack_public_path__ + "static/media/edit-white.f6ffdbca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/edit-white.svg
// module id = 302
// module chunks = 0